import CollectionsRoundedIcon from "@mui/icons-material/CollectionsRounded";

import { Route } from "react-router-dom";
import Reports from "./AdyogiExternalReports";
import DashboardNavCollapsableWithCustomNav from "components/Layout/DashboardNavCollapsableWithCustomNav/DashboardNavCollapsableWithCustomNav";
import { arrType, datatypes, inputTypes } from "data/globalData";
import { custom, externalTypes } from "data/authData";

export const adyogiReportsDashboardSideNavList = {
	// SALE: {
	// 	name: "Sale",
	// 	key: "SALE",
	// 	icon: <TrendingUpRounded />,
	// 	display: true,
	// 	types: {
	// 		all_channel_sale: {
	// 			name: "All CH Sale",
	// 			key: "all_channel_sale",
	// 			icon: <StoreRounded />,
	// 			display: true,
	// 		},
	shopify_live_sale: {
		name: "Shopify Live Sale",
		key: "shopify_live_sale",
		display: true,
		icon: <CollectionsRoundedIcon />,
	},
	// 	},
	// },
};

// Recursive function to build routes
export const generateAdyogiReportsRoutesFromServiceTree = (service, rootPath) => {
	if (service?.types)
		return (
			<Route key={service.key} path={service.key}>
				{service.types &&
					Object.keys(service.types).map((childKey) =>
						generateAdyogiReportsRoutesFromServiceTree(service.types[childKey], rootPath)
					)}
			</Route>
		);
	else
		return (
			<Route
				key={service.key}
				path={service.key}
				element={
					<DashboardNavCollapsableWithCustomNav
						drawerList={adyogiReportsDashboardSideNavList}
						searchParamName="tab"
						navSpace={0}
						service={service}
						pathName={service.key}
						rootPath={rootPath}
						baseUrl={`/external/${externalTypes.ADYOGI.key}`}
					/>
				}>
				<Route index element={<Reports />} />
			</Route>
		);
};

export const groupByoptions = {
	hour: {
		name: "Hour",
		key: "hour",
	},
	day: {
		name: "Day",
		key: "day",
	},
};
export const moreOptions = {
	export: {
		name: "Export",
		key: "export",
	},
};
export const filterColArry = [
	// {
	// 	name: "Group BY",
	// 	key: "group_by",
	// 	input_type: inputTypes.SELECT.key,
	// 	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.STRING.key,
	// 	sort_no: 1,
	// 	group: "",
	// 	placeholder: "",
	// 	default_value: "",
	// 	select_options: {
	// 		type: arrType,
	// 		list: [
	// 			{ name: "Hour", key: "hour" },
	// 			{ name: "Day", key: "day" },
	// 		],
	// 	},
	// },
	{
		name: "Product Vendor",
		key: "product_vendor",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// // { name: allOption, key: allOption },
				// { name: "RARE RABBIT", key: "RARE RABBIT" },
				// { name: "RAREISM", key: "RAREISM" },
				// { name: "RAREONES", key: "RAREONES" },
			],
		},
	},
	{
		name: "Product Type",
		key: "product_type",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// // { name: allOption, key: allOption },
				// { name: "RARE RABBIT", key: "RARE RABBIT" },
				// { name: "RAREISM", key: "RAREISM" },
				// { name: "RAREONES", key: "RAREONES" },
			],
		},
	},
	{
		name: "Sales Channel",
		key: "sales_channel",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// // { name: allOption, key: allOption },
				// { name: "RARE RABBIT", key: "RARE RABBIT" },
				// { name: "RAREISM", key: "RAREISM" },
				// { name: "RAREONES", key: "RAREONES" },
			],
		},
	},
];
